import React from 'react';
import PropType from 'prop-types';
import styled, { keyframes } from 'styled-components';

const Toast = ({ mode, onClose, message }) => {
  return (
    <ToastItem mode={mode} onClick={onClose}>
      {message}
    </ToastItem>
  );
};

const handleColorType = (color) => {
  switch (color) {
    case 'success':
      return '#a5d25f';
    case 'info':
      return '#1f85fd';
    case 'warning':
      return '#fde349';
    case 'error':
      return '#f6666a';
    default:
      return '#1f85fd';
  }
};

const fadeIn = keyframes`
  from{
    opacity: 0;
  } to {
    opacity: 1;
  }
`;

const ToastItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 75px;
  background-color: ${({ mode }) => handleColorType(mode)};
  margin-bottom: 1rem;
  padding: 15px;
  color: white;
  cursor: pointer;
  border-radius: 5px;
  box-sizing: border-box;
  box-shadow: 0px 0px 2px rgb(69, 69, 69);
  transition: 0.2s;
  animation: ${fadeIn} 0.75s;

  &:hover {
    transition: 0.2;
    transform: scale(0.99);
    box-shadow: 0px 0px 3px gray;
  }
`;

Toast.propTypes = {
  mode: PropType.string.isRequired,
  onClose: PropType.func.isRequired,
  message: PropType.string.isRequired,
};

export default Toast;
